// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconUserSexTransgender_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s12IconSvg = html `<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M2.10799 2.87167C1.92215 2.95416 1.71643 3 1.5 3C0.671573 3 0 2.32843 0 1.5C0 0.671573 0.671573 0 1.5 0C2.32843 0 3 0.671573 3 1.5C3 1.71228 2.95591 1.91425 2.87638 2.09727L3.77109 2.99199C4.32018 2.38289 5.11537 2 6 2C6.8896 2 7.68876 2.3872 8.23814 3.00227L10.2404 1H9V0H12V3H11V1.78319L8.81708 3.96611C8.93541 4.28841 9 4.63666 9 5C9 6.4865 7.91886 7.72048 6.5 7.95852V10H7.5V11H6.5V12H5.5V11H4.5V10H5.5V7.95852C4.08114 7.72048 3 6.4865 3 5C3 4.6313 3.06651 4.27814 3.18819 3.95186L2.10799 2.87167ZM6 7C7.10457 7 8 6.10457 8 5C8 3.89543 7.10457 3 6 3C4.89543 3 4 3.89543 4 5C4 6.10457 4.89543 7 6 7Z" class="svg-bg"/>
</svg>
`;
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.00112 0H15.0011L15.0011 6H13.0011V3.41406L11.4472 4.96793C11.7992 5.56346 12.0011 6.25815 12.0011 7C12.0011 8.86424 10.7258 10.4306 9.00002 10.8743V12H11V14H9.00002V16H7.00002V14H5.00001V12H7.00002V10.8737C5.27535 10.4293 4.00112 8.86344 4.00112 7C4.00112 6.26255 4.20068 5.5717 4.54876 4.97853L1.42188 1.85168L2.8361 0.437474L5.95868 3.56003C6.55652 3.20431 7.25496 3 8.00112 3C8.74288 3 9.43749 3.20191 10.033 3.55376L11.5868 2H9.00112V0ZM8.00112 9C9.10569 9 10.0011 8.10457 10.0011 7C10.0011 5.89543 9.10569 5 8.00112 5C6.89655 5 6.00112 5.89543 6.00112 7C6.00112 8.10457 6.89655 9 8.00112 9Z" class="svg-bg"/>
  <path d="M5 2C5 3.10457 4.10457 4 3 4C1.89543 4 1 3.10457 1 2C1 0.89543 1.89543 0 3 0C4.10457 0 5 0.89543 5 2Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M4.29352 5.70758C3.90186 5.89503 3.46319 6 3 6C1.34315 6 0 4.65685 0 3C0 1.34315 1.34315 0 3 0C4.65685 0 6 1.34315 6 3C6 3.46311 5.89507 3.9017 5.70768 4.29331L7.26175 5.84738C8.50841 4.70038 10.1724 4 12 4C13.8276 4 15.4916 4.7004 16.7383 5.84743L20.5857 2H18V0H24V6H22V3.41416L18.0082 7.406C18.638 8.45656 19 9.686 19 11C19 14.5265 16.3923 17.4439 13 17.9291V20H15V22H13V24H11V22H9V20H11V17.9291C7.60771 17.4439 5 14.5265 5 11C5 9.68597 5.36206 8.45651 5.99187 7.40593L4.29352 5.70758ZM12 16C14.7614 16 17 13.7614 17 11C17 8.23858 14.7614 6 12 6C9.23858 6 7 8.23858 7 11C7 13.7614 9.23858 16 12 16Z" class="svg-bg"/>
</svg>
`;
/**
 * IconUserSexTransgender is a generated icon component.
 */
let IconUserSexTransgender = IconUserSexTransgender_1 = class IconUserSexTransgender extends IconBaseElement {
    render() {
        return html `${IconUserSexTransgender_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconUserSexTransgender.icons = new Map([
    ['s8', _s12IconSvg],
    ['s12', _s12IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconUserSexTransgender = IconUserSexTransgender_1 = __decorate([
    customElement('zui-icon-user-sex-transgender')
], IconUserSexTransgender);
export { IconUserSexTransgender };
